import { ReactNode } from "react";
import { Select } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import styles from "./MobileCardSelector.module.scss";

export interface MobileCardSelectorOption {
  id: API.CardId;
  label: string;
}

export interface MobileCardSelectorProps {
  cardId: API.CardId;
  options: MobileCardSelectorOption[];
  onChange: (id: API.CardId) => void;
}

const MobileCardSelector = ({
  cardId,
  options,
  onChange,
}: MobileCardSelectorProps): ReactNode => {
  const { l10n } = useLocalization();
  const label = l10n.getString("subscription-card-label", null, "Card");

  return (
    <div className={styles.container}>
      <Select
        label={label}
        value={cardId}
        onChange={onChange as (cardId: string) => void}
        disabled={options.length === 0}
      >
        {options.map((option) => (
          <Select.Item key={option.id} value={option.id}>
            {option.label}
          </Select.Item>
        ))}
      </Select>
    </div>
  );
};

export default MobileCardSelector;
